module.exports = __webpack_public_path__ + "static/img/7_male.a411463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/character/7_male.png
// module id = LO+h
// module chunks = 0